module.exports = __webpack_public_path__ + "img/24_2nd-protion.314b6885.png";